import { render, staticRenderFns } from "./HomeAdministrator.vue?vue&type=template&id=123f1982&"
import script from "./HomeAdministrator.vue?vue&type=script&lang=js&"
export * from "./HomeAdministrator.vue?vue&type=script&lang=js&"
import style0 from "./HomeAdministrator.vue?vue&type=style&index=0&id=123f1982&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports